import { render } from "./AdditionalExhibitorForm.vue?vue&type=template&id=2d67f696&scoped=true"
import script from "./AdditionalExhibitorForm.vue?vue&type=script&lang=js"
export * from "./AdditionalExhibitorForm.vue?vue&type=script&lang=js"

import "./AdditionalExhibitorForm.vue?vue&type=style&index=0&id=2d67f696&scoped=true&lang=css"

import exportComponent from "/Users/diekstra/PhpstormProjects/rbs-vlb-reservations/rvr-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d67f696"]])

export default __exports__